<template>
  <div id="generate-webhook" class="editor-modal">
    <h2>{{ isFixedConnector ? $t("webhook.title-webhook") : $t("webhook.title-endpoint") }}</h2>

    <form @submit.stop.prevent>
      <span>{{ $t("webhook.info1") }}</span>
      <router-link @click.native="$emit('close')" to="/settings/api-keys">{{ $t("webhook.info-link") }} </router-link>
      <span>{{ $t("webhook.info2") }}</span>
      <a @click="onCreateNewKey">{{ $t("webhook.info-link2") }}</a>
      <span>{{ $t("webhook.info3") }}</span>

      <custom-input
        v-if="!newKey"
        class="api-input"
        v-model="apikey"
        :inputType="'text'"
        :name="'ApiForHook'"
        :label="$t('data.existing-api-key')"
        :placeholder="$t('data.api-key')"
        :focusInputField="true"
        @option-btn-clicked="toggleNewKey"
        :optionBtn="true"
        :btnVisible="true"
        :btnText="$t('webhook.api-key-btn')"
        :btnPadding="true"
      />
      <custom-input
        v-else
        class="api-input"
        v-model="newKeyName"
        :inputType="'text'"
        :name="'newApiKey'"
        :label="$t('webhook.new-key-label')"
        :placeholder="$t('webhook.new-key-placeholder')"
        :focusInputField="true"
        @option-btn-clicked="toggleNewKey"
        :optionBtn="true"
        :btnVisible="true"
        :btnText="$t('webhook.new-key-btn')"
        ref="newApiInput"
        :btnPadding="true"
      />

      <div class="result" v-if="generated">
        <input ref="copier" type="text" v-model="webhook" />

        <div class="copy-to-clipboard" @click="copyToClipboard()">
          <i class="fa-light fa-clipboard"></i>
          <span>{{ $t("webhook.copy-text") }}</span>
        </div>

        <div v-if="copied" class="copy-message">
          {{ $t("webhook.copy-msg") }}
        </div>
      </div>

      <div class="footer">
        <button class="btn btn-md btn-primary" :disabled="!valid" type="submit" @click="generateWebhook()">
          <span v-show="loading"><i class="fa-light fa-circle-notch fa-spin"></i> </span>
          <span v-show="!loading">{{ $t("webhook.generate") }}</span>
        </button>
        <button class="btn btn-md btn-secondary" type="reset" @click="$emit('close')">
          {{ $t("template.cr-tp-btn-cancel") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import appHelper from "@/assets/js/appHelper.js";
import CustomInput from "@/components/CustomInput";
export default {
  props: {
    publication: Object,
  },
  data() {
    return {
      webhook: "",
      apikey: "",
      generated: false,
      copied: false,
      newKey: false,
      newKeyName: "",
      loading: false,
    };
  },
  methods: {
    onCreateNewKey() {
      this.newKey = true;
      this.$nextTick(() => {
        this.$refs.newApiInput.focus();
      });
    },
    toggleNewKey() {
      this.newKey = !this.newKey;
    },
    generateWebhook() {
      if (this.newKey) {
        this.loading = true;
        const data = {
          name: this.newKeyName,
          scopes: ["template_generate"],
        };
        this.$store.dispatch("getApiKeys").then(() => {
          this.$store.dispatch("addApi", JSON.stringify(data)).then((res) => {
            this.apikey = res.key;
            this.webhook = this.generatedHook;
            this.generated = true;
            this.loading = false;
          });
        });
      } else {
        this.webhook = this.generatedHook;
        this.generated = true;
      }
    },
    copyToClipboard() {
      appHelper.copyToClipboard(this.webhook);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
  },
  computed: {
    isFixedConnector() {
      return this.$store.state.fixedConnectors.map((c) => c.value).includes(this.publication.contentType.name);
    },
    generatedHook() {
      if (this.isFixedConnector == true)
        return "https://api.icrobotics.com/templates/" + this.publication.id + "/trigger?x-api-key=" + this.apikey;
      else
        return (
          "https://api.icrobotics.com/templates/" +
          this.publication.id +
          "/generate?contentId={contentId}&x-api-key=" +
          this.apikey
        );
    },
    valid() {
      return this.newKey ? this.newKeyName : this.apikey;
    },
  },
  components: {
    CustomInput,
  },
};
</script>

<style lang="less">
#generate-webhook {
  padding: 30px 25px 25px 25px;
  h2 {
    margin: 0;
  }
  .footer {
    margin-top: 20px;
  }
  .info {
    cursor: default;
  }
  .result {
    position: relative;
    input {
      width: 100%;
      height: 40px;
      margin-bottom: 10px;
    }
  }
  .api-input {
    margin: 0 0 12px 0;
  }
  .copy-message {
    color: #fff;
    position: absolute;
    left: 20px;
    bottom: 20px;
    background-color: var(--charcoal);
    box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.041);
    padding: 5px 10px;
    transform-origin: 0;
  }
  .copy-to-clipboard {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    color: var(--charcoal-75);
  }
}
</style>
